<template>
  <div>
    <div v-intersect.quiet="endIntersect" />
    <v-list-item class="list-filters__loading-item px-2">
      <v-progress-linear indeterminate color="primary" height="4" />
    </v-list-item>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'AppLoadMoreLoader',

  emits: ['end:intersect'],

  methods: {
    endIntersect (isIntersecting: boolean) {
      if (!isIntersecting) {
        return;
      }

      this.$emit('end:intersect');
    }
  }
})
</script>
